import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import JisButton from "../../components/controls/jisButton";
import JisTable from "../../components/controls/jisTable";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import JisTabButton from "../../components/controls/jisTabButton";
import BackLoader from "../../components/backloader";
import JisAlert from "../../components/jisalert";
import * as Services from "../../services";
import JisDialog from "../../components/dialog";

// NIN / Payer ID / business registration only apply to external filing accounts
// (Legal Counsel, or the Legal / Non-Legal filing roles) - not to internal staff
// such as Judges, PSA, CFO, ACR, Admin...
const needsPayerDetails = (u) =>
  !!u?.isLegalCounsel ||
  [Constants.Legal_Role_id, Constants.Non_Legal_Role_id].includes(Number(u?.roleId));

// Government accounts (isGov - kept on the profile as isMinistryOfJustice) do not have to
// provide Business Type, RC Number or Industry as an Organisation.
const isGovAccount = (u) => !!(u?.isGov || u?.isMinistryOfJustice);


function UpdateProfile() {
  const { activePage, token, profile, frequentData, setIsExpired, setAlert } =
    useContext(ShareContext);
  const [states, setStates] = useState([]);
  const [Lga, setLga] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({ roleId: null, isOrg: false });
  const [payidgen, setPayidgen] = useState(false);
  const [isNin, setIsNin] = useState(true);
  const [isPass, setIsPass] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const [tab, setTab] = useState("info");
  const [openLegalDoc, setOpenLegalDoc] = useState(false);
  const [typeTemp, setTypeTemp] = useState("");
  const [isUploadClick, setIsUploadClick] = useState(false);
  const [uploadType, setUploadType] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedFile, setActiveFile] = useState();
  const urlSaveInst = `${Constants.apiUrl}/filing/uploadinstrument`;
  const urlInstrument = `${Constants.apiUrl}/filing/instrument/`;
  const [seal, setSeal] = useState("");
  const [passport, setPassport] = useState("");
  const [sign, setSign] = useState("");
  const [stamp, setStamp] = useState("");
  const [initial, setInitial] = useState("");
  const [imgPrev, setImgPrev] = useState({ data: "", type: "", open: false });
  const [parent, setParent] = useState(null);
  const [payeridValidation, setPayeridValidation] = useState(null);
  const [payIdCreated, setPayIdCreated] = useState(false);
  const [flowerror, setFlowError] = useState("");

  useEffect(() => {
    onLoadProfile();
  }, []);
  useEffect(() => {
    if (payeridValidation != null) {
      //proceed
      // setFlow({pos:4,code:"access"})
      console.log(payeridValidation);
      if (payeridValidation.Status == "SUCCESS") {
        const pid = payeridValidation.Pid?.match(/\(([A-Z]-\d+)\)/i);

        setPayIdCreated(true);
        setUser({ ...user, payerId: pid[1] });
      } else {
        if (payeridValidation.status) {
          setFlowError(
            `${payeridValidation.status} - ${payeridValidation.statusMessage}`,
          );
        } else {
          setFlowError(
            `${payeridValidation.Status} - ${payeridValidation.StatusMessage}`,
          );
        }
      }
    }
  }, [payeridValidation]);

  const onCreatePayerId = async () => {
    setFlowError("");
    setPayeridValidation(null);
    console.log(user.nin);
    if (!user.isOrg && (user.nin == undefined || user.nin == "")) {
      setFlowError(`Please provide NIN information`);
      return;
    }
    if (
      user.isOrg &&
      !isGovAccount(user) &&
      (user.businessType == "" ||
        user.rcNumber == "" ||
        user.businessIndustry == "")
    ) {
      setFlowError(`Please provide Organization details`);
      return;
    }

    setLoading(true);
    try {
      var _user = { ...user, isOrg: user.isOrg == null ? false : user.isOrg };

      const resp = await fetch(`${Constants.apiUrl}/profile/create-payer-id`, {
        method: "POST",
        body: JSON.stringify(_user),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: "",
        },
      });

      const data = await resp.json();
      setLoading(false);

      if (data.code == 0) {
        setPayeridValidation(data.payerid);
      } else {
        console.log(data);
        console.log(`the error received.`);
        setFlowError(data.satus);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setFlowError("cannot connect to the server at the moment. Try again");
      // onMove();
    }
  };

  const onLoadProfile = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/profile`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      if (data.code == 0) {
        setUser(data.profile);
        setParent(data.parentAccount);
        for (const x of data.instruments) {
          onSetImg(x.instPath, x.instrument);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const gender = [
    { label: "Male", value: "M" },
    { label: "Female", value: "F" },
  ];

  useEffect(() => {
    async function fetchData() {
      const c = await Services.onGetStates();
      //get latest 20 records from db in addition
      setStates(c);
    }
    fetchData();
  }, []);
  useEffect(() => {
    async function fetchData() {
      if (user.state) {
        const c = await Services.onGetLgs(user.state);
        setLga(c);
      }
    }
    fetchData();
  }, [user.state]);

  useEffect(() => {
    async function fetchData() {
      if (user.lga) {
        const c = await Services.onGetCities(user.lga);
        setCities(c);
      }
    }
    fetchData();
  }, [user.lga]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setActiveFile(file);
    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        setSelectedImage(reader.result);
      };

      reader.readAsDataURL(file);
    }
  };

  const openTemp = (type) => {
    setOpenLegalDoc(true);

    if (type === "affidavit") {
      setTypeTemp("affidavit");
    } else if (type === "case-doc") {
      setTypeTemp("case-doc");
    }
  };

  const openUpload = (item) => {
    setIsUploadClick(true);

    if (item === "sign") {
      setUploadType("Signature");
    } else if (item === "seal") {
      setUploadType("Seal");
    } else if (item === "stamp") {
      setUploadType("Stamp");
    } else if (item === "passport") {
      setUploadType("Passport");
    } else if (item === "initial") {
      setUploadType("Initial");
    }
  };

  const cancelUpload = () => {
    setIsUploadClick(false);

    setSelectedImage(null);
  };
  const onSaveInst = () => {
    onUploadIns();
  };
  const onUploadIns = async () => {
    console.log("imgPrev data");
    console.log(selectedImage);

    setLoading(true);
    //setImgPrev({...imgPrev,open:true,data:e.target.result,type:inst, title:"Upload "+inst, });
    var ext = selectedFile.name.split(".")[1];
    var b64 = await Constants.toBase64(selectedFile);
    var rdata = {
      base64: b64.split(",")[1],
      instType: uploadType,
      ext,
      changereason: "Initial",
    };
    // Sending the FormData using fetch
    fetch(urlSaveInst, {
      method: "POST",
      body: JSON.stringify(rdata),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.code == 0) {
          //saved already

          setAlert({
            ...alert,
            title: imgPrev.type,
            open: true,
            subtitle: `${imgPrev.type} Saved Successfully`,
            onOk,
          });
          setIsUploadClick(false);
          onSetImg(data.instPath, uploadType);
          setSelectedImage(null);
          setActiveFile(null);
          setUploadType("");
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };

  const onOk = () => {
    setAlert({ open: false });
  };
  const onSetImg = (path, type) => {
    const ct = type.toLowerCase();
    if (ct == "seal") {
      setSeal(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "passport") {
      setPassport(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "signature") {
      setSign(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "initial") {
      setInitial(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "stamp") {
      setStamp(`${Constants.docUrl}instrument/${path}`);
    }
  };

  const onUserChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };
  // Individual (isOrg=false) / Organisation (isOrg=true) decides which profile fields are shown and required
  const onAccountTypeChange = (e) => {
    setUser({ ...user, isOrg: e.target.value === "1" });
  };
  const onSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/profile/update-profile/${profile.id}`,
        {
          method: "POST",
          body: JSON.stringify(user),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setAlert({
          open: true,
          title: "Update Profile",
          subtitle: "The profile record updated successfully",
        });
      } else if (data.code == -10) {
        setIsExpired(true);
      }

      setIsSuccess(true);
    } catch (error) {
      setLoading(false);
      console.error(error);

      // onMove();
    }
  };
  const businessType = [
    { label: "RC", value: "RC" },
    { label: "BN", value: "BN" },
    { label: "IT", value: "IT" },
  ];

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ flex: 1 }}>
          <form onSubmit={onSave}>
            <div style={{ flex: 1 }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex" }}>
                  <div className="select-group">
                    <label>
                      Account Type <span className="required">*</span>
                    </label>
                    <select
                      name="accountType"
                      value={user.isOrg ? "1" : "0"}
                      required
                      onChange={onAccountTypeChange}
                    >
                      <option value="0">Individual</option>
                      <option value="1">Organisation</option>
                    </select>
                  </div>
                </div>
                {user.isOrg ? (
                  <div className="input-group">
                    <label> Organization Name</label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="person_3" />
                      <input
                        placeholder="Organization Name"
                        required={true}
                        name="firstName"
                        value={user.firstName}
                        onChange={onUserChange}
                      />
                    </div>
                  </div>
                ) : (
                  <div>
                    <div style={{ display: "flex" }}>
                      <div className="select-group">
                        <label>
                          {" "}
                          Title <span className="required">*</span>
                        </label>
                        <select
                          name="suffix"
                          value={user.suffix}
                          onChange={onUserChange}
                          required
                        >
                          <option value="">Select Title</option>
                          <option value="Mr">Mr</option>
                          <option value="Mrs">Mrs</option>
                          <option value="Miss">Miss</option>
                          <option value="Dr">Dr</option>
                          <option value="Dr(Mrs)">Dr(Mrs)</option>
                          <option value="Chief">Chief</option>
                          <option value="Chief(Mrs)">Chief(Mrs)</option>
                          <option value="Engr">Engr</option>
                          <option value="Engr(Mrs)">Engr(Mrs)</option>
                          <option value="Alhaji">Alhaji</option>
                          <option value="Alhaja">Alhaja</option>
                          <option value="Rev">Rev</option>
                          <option value="Pastor">Pastor</option>
                          <option value="Admiral">Admiral</option>
                          <option value="General">General</option>
                          <option value="Air Comm.">Air Comm.</option>
                          <option value="Captain">Captain</option>
                          <option value="Lt. Col">Lt. Col</option>
                          <option value="Rev(Mrs)">Rev(Mrs)</option>
                          <option value="Bishop">Bishop</option>
                          <option value="Arch Bishop">Arch Bishop</option>
                          <option value="Primate">Primate</option>
                          <option value="Architect">Architect</option>
                        </select>
                      </div>
                      <div className="input-group">
                        <label>Alias </label>
                        <div className="input-wrapper">
                          <DynamicIcon iname="person_3" />
                          <input
                            name="alias"
                            value={user.alias}
                            onChange={onUserChange}
                            placeholder="Alias"
                          />
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="input-group">
                        <label>
                          Surname/Last name <span className="required">*</span>
                        </label>
                        <div className="input-wrapper">
                          <DynamicIcon iname="person_3" />
                          <input
                            name="lastName"
                            required={true}
                            value={user.lastName}
                            onChange={onUserChange}
                            placeholder="surname/lastname"
                          />
                        </div>
                      </div>
                    </div>
                    <div style={{ display: "flex" }}>
                      <div className="input-group">
                        <label>
                          {" "}
                          First Name <span className="required">*</span>
                        </label>
                        <div className="input-wrapper">
                          <DynamicIcon iname="person_3" />
                          <input
                            label=""
                            placeholder="Firstname"
                            required={true}
                            name="firstName"
                            value={user.firstName}
                            onChange={onUserChange}
                          />
                        </div>
                      </div>

                      <div className="input-group">
                        <label> Middle Name</label>
                        <div className="input-wrapper">
                          <DynamicIcon iname="person_3" />
                          <input
                            label=""
                            placeholder="Middle Name"
                            name="middleName"
                            value={user.middleName}
                            onChange={onUserChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="input-group">
                  <label>
                    Address <span className="required">*</span>
                  </label>
                  <div className="input-wrapper">
                    <DynamicIcon iname="add_home" />
                    <input
                      placeholder="address1"
                      name="address1"
                      required={true}
                      value={user.address1}
                      onChange={onUserChange}
                    />
                  </div>
                </div>

                {!user.isOrg && (
                <div style={{ display: "flex" }}>
                  <div className="input-group">
                    <label>
                      {" "}
                      Date of Birth <span className="required">*</span>
                    </label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="calendar-days" />
                      <input
                        placeholder="Date of Birth"
                        type="date"
                        required
                        name="dateOfBirth"
                        value={user.dateOfBirth}
                        onChange={onUserChange}
                      />
                    </div>
                  </div>
                </div>
                )}

                {!user.isOrg && (
                  <div style={{ display: "flex" }}>
                    <div className="select-group">
                      <label>
                        Gender <span className="required">*</span>
                      </label>
                      <select
                        name="sex"
                        value={user.sex}
                        required={true}
                        onChange={onUserChange}
                      >
                        <option value="">Select gender</option>
                        {gender.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="select-group">
                      <label> Marital Status</label>

                      <select
                        name="maritalStatus"
                        value={user.maritalStatus}
                        onChange={onUserChange}
                        required={true}
                      >
                        <option value="">Select marital Status</option>
                        <option value="M">Married</option>
                        <option value="S">Single</option>
                        <option value="W">Widow/Widower</option>
                        <option value="D">Divorced</option>
                      </select>
                    </div>
                  </div>
                )}

                <div style={{ display: "flex" }}>
                  <div className="input-group">
                    <label>
                      {" "}
                      Primary Email <span className="required">*</span>
                    </label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="email" />
                      <input
                        name="primaryEmail"
                        type="email"
                        required
                        value={user.primaryEmail}
                        onChange={onUserChange}
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="input-group">
                    <label>
                      {" "}
                      Primary Phone <span className="required">*</span>
                    </label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="phone_in_talk" />
                      <input
                        placeholder="primaryphone"
                        type="tel"
                        name="primaryContactNumber"
                        required={true}
                        value={user.primaryContactNumber}
                        onChange={onUserChange}
                      />
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex" }}>
                  <div className="select-group">
                    <label>Division</label>
                    <select
                      name="divisionId"
                      value={user.divisionId}
                      onChange={onUserChange}
                    >
                      <option value="">Select </option>
                      {frequentData.divisions?.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label>
                      {" "}
                      State <span className="required">*</span>
                    </label>
                    <select
                      name="state"
                      required={true}
                      value={user.state}
                      onChange={onUserChange}
                      options={gender}
                    >
                      <option value="">Select state</option>
                      {states.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label>
                      {" "}
                      L.G.A <span className="required">*</span>
                    </label>
                    <select
                      name="lga"
                      value={user.lga}
                      required={true}
                      onChange={onUserChange}
                    >
                      <option value="">Select LG</option>
                      {Lga.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="select-group">
                    <label>
                      {" "}
                      City <span className="required">*</span>
                    </label>
                    <select
                      name="city"
                      value={user.city}
                      required={true}
                      onChange={onUserChange}
                    >
                      <option value="">City</option>
                      {cities.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {user.isLegalCounsel && (
                  <div>
                    <div className="input-group">
                      <label>
                        {" "}
                        Supreme Court Number<span className="required">*</span>
                      </label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="phone_in_talk" />
                        <input
                          placeholder="Supreme Court Number"
                          name="barNumber"
                          required={true}
                          value={user.barNumber}
                          onChange={onUserChange}
                          maxLength={9}
                        />
                      </div>
                    </div>
                    <note>
                      Legal counsel is required to provide Supreme Court Number
                    </note>
                  </div>
                )}
                {needsPayerDetails(user) &&
                  !user.isOrg &&
                  (user.payerId == null || user.payerId == "") && (
                    <div>
                      <div className="input-group">
                        <label>
                          {"NIN"} {user.isOrg}{" "}
                          <span className="required">*</span>
                        </label>
                        <div className="input-wrapper">
                          <DynamicIcon iname="card" />
                          <input
                            placeholder={`Enter your NIN number`}
                            name="nin"
                            type="number"
                            maxLength={11}
                            value={user.nin}
                            required
                            onChange={onUserChange}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                {needsPayerDetails(user) &&
                  user.isOrg &&
                  (user.payerId == null || user.payerId == "") && (
                  <div style={{ display: "flex" }}>
                    <div className="select-group">
                      <label>
                        {" "}
                        Business Type {!isGovAccount(user) && <span className="required">*</span>}
                      </label>

                      <select
                        name="businessType"
                        value={user.businessType}
                        onChange={onUserChange}
                        required={!isGovAccount(user)}
                      >
                        <option value="">Select Business Type</option>
                        {businessType.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="input-group">
                      <label>
                        {user.businessType} Number{" "}
                        {!isGovAccount(user) && <span className="required">*</span>}
                      </label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="card" />
                        <input
                          placeholder={`Enter your ${user.businessType} Number`}
                          name="rcNumber"
                          type="number"
                          maxLength={15}
                          value={user.rcNumber}
                          required={!isGovAccount(user)}
                          onChange={onUserChange}
                        />
                      </div>
                    </div>
                    <div className="input-group">
                      <label>
                        {" "}
                        Industry {!isGovAccount(user) && <span className="required">*</span>}
                      </label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="card" />
                        <input
                          placeholder={`Enter your Business Industry`}
                          name="businessIndustry"
                          maxLength={100}
                          value={user.businessIndustry}
                          required={!isGovAccount(user)}
                          onChange={onUserChange}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {needsPayerDetails(user) && (
                  <div className="payeridbox">
                    <label>Payer ID</label>
                    <div className="input-group">
                      <div className="input-wrapper">
                        <DynamicIcon iname="card" />
                        <input
                          placeholder={`${user.isOrg ? "C" : "N"}-123456`}
                          name="payerId"
                          pattern="^(N|C)-\d{1,12}$"
                          value={user.payerId ?? ""}
                          title="Must start with N- or C- followed by 4 to 12 digits"
                          onChange={onUserChange}
                          max={15}
                          disabled={
                            !!user.payerId &&
                            !profile?.role?.name
                              ?.toLowerCase()
                              .includes("admin")
                          }
                        />
                      </div>
                    </div>
                    {(user.payerId === null || user.payerId === "") && (
                      <JisButton onClick={onCreatePayerId}>
                        Generate Payer ID
                      </JisButton>
                    )}
                    {flowerror !== "" && (
                      <div className="error">{flowerror}</div>
                    )}
                  </div>
                )}
                {parent != null && (
                  <div style={{ margin: 16 }}>
                    <strong>Parent Account: </strong> {parent.suffix}{" "}
                    {parent.firstName} {parent.lastName ?? ""}
                  </div>
                )}
              </div>
              <div>
                <h2>Access Information</h2>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ flex: 1 }}>
                    <div>
                      <div className="input-group">
                        <label>
                          {" "}
                          Username <span className="required">*</span>
                        </label>
                        <div className="input-wrapper">
                          <DynamicIcon iname="person_3" />
                          <input
                            placeholder="username"
                            name="userName"
                            value={user.userName}
                            onChange={onUserChange}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div style={{ display: "flex" }}>
                      <div className="input-group">
                        <label>Password </label>
                        <div className="input-wrapper">
                          <DynamicIcon iname="lock" />
                          <input
                            placeholder="Please leave empty if you not intending to change password"
                            type={`${isPass ? "password" : "text"}`}
                            name="password"
                            value={user.password}
                            onChange={onUserChange}
                          />
                          <DynamicIcon
                            iname={`${isPass ? "visibility" : "visibility_off"}`}
                            onClick={() => setIsPass(!isPass)}
                          />
                        </div>
                      </div>
                      <div className="input-group">
                        <label> Confirm Password </label>
                        <div className="input-wrapper">
                          <DynamicIcon iname="lock" />
                          <input
                            placeholder="confirmpassword "
                            name="confirmpassword"
                            type={`${isPass ? "password" : "text"}`}
                            value={user.confirmpassword}
                            onChange={onUserChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <JisButton type="submit"> Save</JisButton>
            </div>
          </form>
        </div>
        <div style={{ flex: 1 }}>
          <div className="action-btns-instru" style={{ flexWrap: "wrap" }}>
            <div className="upload-dash" onClick={() => openUpload("initial")}>
              {initial == "" ? (
                <div className="icon-text">
                  <DynamicIcon iname="check_circle" />
                  <p>Upload Initial</p>
                </div>
              ) : (
                <img
                  src={initial}
                  alt="Initial"
                  style={{ width: 100, height: 100 }}
                />
              )}
              {initial != "" && (
                <div className="icon-text">
                  {" "}
                  <p> Initial</p>{" "}
                </div>
              )}
              <DynamicIcon iname="info" />
            </div>
            <div className="upload-dash" onClick={() => openUpload("sign")}>
              {sign == "" ? (
                <div className="icon-text">
                  <DynamicIcon iname="check_circle" />
                  <p>Upload Signature</p>
                </div>
              ) : (
                <img
                  src={sign}
                  alt="Signature"
                  style={{ width: 100, height: 100 }}
                />
              )}
              {sign != "" && (
                <div className="icon-text">
                  {" "}
                  <p> Signature</p>{" "}
                </div>
              )}
              <DynamicIcon iname="info" />
            </div>
            <div className="upload-dash" onClick={() => openUpload("seal")}>
              {seal == "" ? (
                <div className="icon-text">
                  <DynamicIcon iname="check_circle" />
                  <p>Upload Seal</p>
                </div>
              ) : (
                <img
                  src={seal}
                  alt="Seal"
                  style={{ width: 100, height: 100 }}
                />
              )}
              {seal != "" && (
                <div className="icon-text">
                  {" "}
                  <p> Seal</p>{" "}
                </div>
              )}
              <DynamicIcon iname="info" />
            </div>

            <div className="upload-dash" onClick={() => openUpload("stamp")}>
              {stamp == "" ? (
                <div className="icon-text">
                  <DynamicIcon iname="stamp" />
                  <p>Upload Stamp</p>
                </div>
              ) : (
                <img
                  src={stamp}
                  alt="Stamp"
                  style={{ width: 100, height: 100 }}
                />
              )}
              {stamp != "" && (
                <div className="icon-text">
                  {" "}
                  <p> Stamp</p>{" "}
                </div>
              )}
              <DynamicIcon iname="info" className="uploaded-it" />
            </div>

            <div className="upload-dash" onClick={() => openUpload("passport")}>
              {passport == "" ? (
                <div className="icon-text">
                  <DynamicIcon iname="check_circle" />
                  <p>Upload Passport</p>
                </div>
              ) : (
                <img
                  src={passport}
                  alt="Passport"
                  style={{ width: 100, height: 100 }}
                />
              )}
              {passport != "" && (
                <div className="icon-text">
                  {" "}
                  <p> Passport</p>{" "}
                </div>
              )}
              <DynamicIcon iname="info" className="uploaded-it" />
            </div>
          </div>
        </div>
      </div>

      {isUploadClick && (
        <JisDialog title="Upload Instrument">
          <div className="upload-wrap">
            <h3>Upload {uploadType}</h3>
            <div className="upload-file-btn">
              <label htmlFor="upload-input">
                {selectedImage ? "Change Image" : "Upload Image"}
              </label>
              <input
                type="file"
                id="upload-input"
                accept="image/*"
                onChange={handleImageChange}
              />
              {selectedImage && (
                <img
                  src={selectedImage}
                  alt="Uploaded Document"
                  style={{ width: 150 }}
                />
              )}
            </div>

            <p className="warn">Maximum File Upload: 2MB</p>

            <button className="red" onClick={() => cancelUpload()}>
              Cancel
            </button>
            <button icon="check_circle" onClick={onSaveInst}>
              Upload
            </button>
          </div>
        </JisDialog>
      )}
    </div>
  );
}

export default UpdateProfile;
